/* DataTypeEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const { typeLabelsList, getTypeData, typeDataByLabel } = require("../CustomFieldsConstants");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class DataTypeEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
    }

    _init() {
        //do not allow to change data type if CF has been saved
        if (!this._isNewItem) {
            setTimeout(this._cancel.bind(this));
            return;
        }
        const options = typeLabelsList.map((label) => ({
            label: label,
            value: typeDataByLabel(label).dataType
        }));
        this.input.setOptions(options);

        super._init();
    }

    applyValue(item, state) {
        super.applyValue(item, state);
        const typeData = getTypeData(state);
        Object.assign(
            item,
            typeData && {
                typeInfo: typeData.typeInfo,
                default: typeData.default
            }
        );
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: false,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false
        });
    }
}

module.exports = DataTypeEditor;
